import { RootState } from '../../rootReducer'

export const selectVideo = (state: RootState) => state.modalPlayer.video
export const selectIsVisible = (state: RootState) => state.modalPlayer.isVisible
